import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  faqs: [],
};

export const createFaq = createAsyncThunk(
  "createFaq/faq",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("faqs", data);
      enqueueSnackbar("Faq is added successfully");
      navigate(PATH_DASHBOARD.manage.faqs.list);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchFaqs = createAsyncThunk(
  "fetchFaqs/faq",
  async ({ enqueueSnackbar, limit = 1000, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(
        `faqs?limit=${limit}&page=${page + 1}`
      );
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateFaq = createAsyncThunk(
  "updateFaq/faq",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`faqs/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteFaq = createAsyncThunk(
  "deleteFaq/faq",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`faqs/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const faqSlice = createSlice({
  name: "faqs",
  initialState,
  extraReducers: (builder) => {
    // TODO: create category
    builder.addCase(createFaq.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createFaq.fulfilled, (state, action) => {
      state.isLoading = false;
      // state.faqs.data = [action.payload, ...state.faqs.data];
      // state.faqs.meta.total = state.faqs.meta.total + 1;
    });

    builder.addCase(createFaq.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch category
    builder.addCase(fetchFaqs.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchFaqs.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.faqs = action.payload;
    });

    builder.addCase(fetchFaqs.rejected, (state, action) => {
      state.fetchLoading = false;
      // action.payload.enqueueSnackbar(action.payload.error.message, {
      //   variant: "error",
      // });
    });

    // ==========================

    // TODO: update category
    builder.addCase(updateFaq.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateFaq.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Faq is updated successfully");
      state.faqs.data = state.faqs.data.map((faq) =>
        faq.id === action.payload.slug ? action.payload.data : faq
      );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateFaq.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message || "error", {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete category
    builder.addCase(deleteFaq.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteFaq.fulfilled, (state, action) => {
      state.isLoading = false;
      state.faqs.data = state.faqs.data.filter(
        (faq) => faq.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Faq is deleted successfully");
    });

    builder.addCase(deleteFaq.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default faqSlice.reducer;
